/**
 * Firebase init — multi-tenant (Identity Platform).
 *
 * CRÍTICO: `auth.tenantId` é setado AQUI, antes de qualquer operação.
 * Sem isso, login cai no tenant default e silenciosamente quebra.
 *
 * Tenant deste app: `mapa-mental-nkduc`
 */
import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { env } from './env'

export const app = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID || undefined,
})

export const auth = getAuth(app)
// Multi-tenant: SEMPRE setar antes de qualquer operação de auth
auth.tenantId = env.VITE_FIREBASE_TENANT_ID

export const db = getFirestore(app)
export const storage = getStorage(app)

// Emuladores (dev local)
if (env.VITE_USE_EMULATORS) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, '127.0.0.1', 8080)
  connectStorageEmulator(storage, '127.0.0.1', 9199)
  // eslint-disable-next-line no-console
  console.info('🧪 Firebase emuladores conectados')
}
